import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-supplier-product',
  templateUrl: './select-supplier-product.component.html',
  styleUrls: ['./select-supplier-product.component.css']
})
export class SelectSupplierProductComponent implements OnInit {

  suppliers: any[] = [];
  supplierSelected: any = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public product: any,
    public dialogRef: MatDialogRef<SelectSupplierProductComponent>
  ) { }

  ngOnInit(): void {
    this.suppliers = this.product.product_supplier;
  }


  confirm() {
    this.dialogRef.close(this.supplierSelected);
  }
}
